import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import debounce from 'lodash.debounce';
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';
import { Buffer } from 'buffer';
import SoldOutModal from "./components/soldOut";
import { getEventPageDetailsById, expireHoldToken } from "../../api";

import supportEmailLogo from "../../assets/imgs/SupportEmail.svg";
import supportPhoneLogo from "../../assets/imgs/SupportPhone.svg";
import info from "../../assets/imgs/info.svg";
import sorry from "../../assets/imgs/sorry.svg";
import {
    Spinner,
} from "../../design";
import "../../assets/css/eventPageStyle.css";
import Products from "./components/products";
import ProductReview from "./components/productReview";
import * as moment from "moment-timezone";
import Icon, { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { AmountDivideByHundred } from "../../helper";
import { createEventPageOrder } from "../../api";
import { notification } from "antd";
import redInfo from "../../assets/imgs/RedInfo.svg";
import backArrow from "../../assets/imgs/backArrowBlack.svg";




const EventPages = (props) => {

    const { match: { params: { eventPageId } }, location: { pathname, search } } = props;
    const [isShowSpinner, setShowSpinner] = useState(false);
    const [eventDetails, setEventDetails] = useState();
    const [mobileView, setMobileView] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const [productScreen, setProductScreen] = useState(false);
    const [path, setPath] = useState('');
    const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [payload, setPayload] = useState({});
    const [showAllDates, setShowAllDates] = useState(false);
    const [payLoading, setPayLoading] = useState(false);
    const [payNow, setPayNow] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isImageModalOpen, setIsImageModalOpen] = useState(false);
    const [modalImageSrc, setModalImageSrc] = useState('');
    const [isTermsExpanded, setIsTermsExpanded] = useState(false);
    const [isVideoDescExpanded, setIsVideoDescExpanded] = useState(false);
    const [isTermsOverflowing, setIsTermsOverflowing] = useState(false);
    const [isVideoDescOverflowing, setIsVideoDescOverflowing] = useState(false);
    const [orderItems, setOrderItems] = useState(() => {
        const storedItems = sessionStorage.getItem('placedItems-' + eventPageId.replace('eventpage-', ''));
        return storedItems ? JSON.parse(storedItems) : [];
    });
    const [selectedDate, setSelectedDate] = useState(null);

    useEffect(() => {
        if (eventDetails && !selectedDate) {
            setSelectedDate(
                eventDetails?.eventPageDateTimes?.length > 0
                    ? eventDetails.eventPageDateTimes[0]
                    : eventDetails?.eventDate
                        ? {
                            eventDate: eventDetails.eventDate,
                            eventStartTime: eventDetails.eventStartTime,
                            eventEndTime: eventDetails.eventEndTime,
                        }
                        : null
            );
        }
    }, [eventDetails, selectedDate]);

    const contentRef = useRef(null);
    const termsRef = useRef(null);
    const videoDescRef = useRef(null);
    const supportRef = useRef(null);
    const supportToggleRef = useRef(null);
    const lastErrorRef = useRef({ message: "", timestamp: 0 });
    const paymentLockRef = useRef(false);

    const lastNotifyRef = useRef(0);
    const debouncedNotify = useMemo(
        () => debounce((msg) => {
            if (!msg) return;
            console.log("Showing Error Toast in EventPages:", msg);
            notification.destroy('event-error-toast'); // Close existing one to ensure it pops up again
            notification.error({
                key: 'event-error-toast', // Fixed key prevents multiple toasts from stacking
                message: "Notification",
                description: msg,
                duration: 4,
                placement: "topRight"
            });
        }, 500, { leading: true, trailing: false }),
        []
    );

    const bannerImages = eventDetails?.bannerImages && eventDetails?.bannerImages.length ? eventDetails?.bannerImages : (eventDetails?.banner ? [eventDetails.banner] : []);

    const extractYoutubeId = (url) => {
        if (!url) return null;
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);
        return (match && match[2].length === 11) ? match[2] : url;
    };

    const nextImage = (e) => {
        e.stopPropagation();
        setCurrentImageIndex((prev) => (prev + 1) % bannerImages.length);
    };

    const prevImage = (e) => {
        e.stopPropagation();
        setCurrentImageIndex((prev) => (prev - 1 + bannerImages.length) % bannerImages.length);
    };

    const openMail = (email) => {
        console.log("Opening mail client for:", email);
        if (!email || !email.includes("@")) {
            alert("Support email not available");
            return;
        }
        
        const mailtoLink = document.createElement("a");
        mailtoLink.href = `mailto:${email}`;
        mailtoLink.style.display = "none";
        document.body.appendChild(mailtoLink);
        mailtoLink.click();
        document.body.removeChild(mailtoLink);
    };

    useEffect(() => {
        if (contentRef.current) {
            setIsOverflowing(contentRef.current.scrollHeight > contentRef.current.clientHeight);
        }
        if (termsRef.current) {
            setIsTermsOverflowing(termsRef.current.scrollHeight > termsRef.current.clientHeight);
        }
        if (videoDescRef.current) {
            setIsVideoDescOverflowing(videoDescRef.current.scrollHeight > videoDescRef.current.clientHeight);
        }
    }, [eventDetails?.description, eventDetails?.termsAndConditions, eventDetails?.ytVideoDescription]);

    const toggleReadMore = () => {
        setIsDescriptionExpanded(!isDescriptionExpanded);
    };


    useEffect(() => {
        const handleResize = () => {
            setMobileView(window.innerWidth < 768);
        };
        handleResize();
        window.addEventListener('resize', handleResize);

        const storedTime = sessionStorage.getItem("expiryTime");
        const timeLeft = storedTime ? Math.trunc((new Date(parseInt(storedTime, 10)).getTime() - new Date().getTime()) / 1000) : null;
        if (timeLeft && timeLeft <= 0) {
            expiredToken();
        }

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const getEventDataWithoutSearchValue = async () => {
        setShowSpinner(true);
        try {
            const value = await getEventPageDetailsById(eventPageId, null);
            if (value && value) {
                setEventDetails(value)
            }

        } catch (e) {
            props.history.push(`${pathname}/error`);
        } finally {
            setShowSpinner(false)
        }
    };

    useEffect(() => {
        if (path) {
            props.history.push(path);
        }
    }, [path]);

    useEffect(() => {
        if (eventPageId) {
            getEventDataWithoutSearchValue();
        }
    }, [eventPageId, search]);

    function isDark(color) {
        if (!color) return true;
        const rgb = getRGB(color);
        const brightness = (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
        return brightness < 128;
    }

    function getRGB(hex) {
        let r, g, b;
        if (hex.startsWith('#')) {
            const value = hex.length === 7 ? hex.slice(1) : hex.slice(1).repeat(2);
            r = parseInt(value.substring(0, 2), 16);
            g = parseInt(value.substring(2, 4), 16);
            b = parseInt(value.substring(4, 6), 16);
        } else {
            [r, g, b] = hex.match(/\d+/g).map(Number);
        }
        return { r, g, b };
    }


    useEffect(() => {
        const color = eventDetails?.primaryColor || "#1890FF";
        document.documentElement.style.setProperty("--primary-color", color);
        if (isDark(color)) {
            document.documentElement.style.setProperty('--text-color', '#0C0C0CFF');
            document.documentElement.style.setProperty('--header-text-color', '#ffffff');
        } else {
            document.documentElement.style.setProperty('--text-color', '#000000');
            document.documentElement.style.setProperty('--header-text-color', '#000000');
        }
    }, [eventDetails]);

    const products = () => {
        setProductScreen(!productScreen);
    };

    const getOperatingTime = (time) => {
        if (time !== undefined && time !== null) {
            const hours = Math.floor(time / 60);
            const minutes = time % 60;
            let min = minutes < 10 ? `0${minutes}` : minutes;
            if (hours > 12) {
                return `${hours - 12}:${min} PM`;
            }
            if (hours === 12) {
                return `12:${min} PM`;
            }
            if (hours === 0) {
                return `12:${min} AM`;
            }
            return `${hours}:${min} AM`;
        }
        return '';
    };

    const getEventTimeRange = (dateOption) => {
        if (!dateOption || dateOption.eventStartTime === undefined || dateOption.eventStartTime === null) return "";
        const startTime = getOperatingTime(dateOption.eventStartTime);
        if (dateOption.eventEndTime === undefined || dateOption.eventEndTime === null || dateOption.eventEndTime === dateOption.eventStartTime) {
            return startTime;
        }
        return `${startTime} - ${getOperatingTime(dateOption.eventEndTime)}`;
    };

    const expiredToken = async () => {
        setProductScreen(false);
        const seats = sessionStorage.getItem('seatsio') ? JSON.parse(sessionStorage.getItem('seatsio')) : undefined;
        if (seats?.holdToken) {
            expireHoldToken(seats.holdToken);
        }

        sessionStorage.removeItem('seatsio');
        sessionStorage.removeItem("expiryTime");
        const baseId = eventPageId.replace('eventpage-', '');
        sessionStorage.removeItem('placedItems-' + baseId);
        const prefix = 'placedLineItems-' + baseId;

        Object.keys(sessionStorage).forEach((key) => {
            if (key.startsWith(prefix)) {
                sessionStorage.removeItem(key);
            }
        });
        setOrderItems([]);
    };



    const openImageModal = (imageSrc) => {
        setModalImageSrc(imageSrc);
        setIsImageModalOpen(true);
    };

    const closeImageModal = () => {
        setIsImageModalOpen(false);
        setModalImageSrc('');
    };
    const createOrderAndPay = async (payload) => {
        if (paymentLockRef.current || payLoading) {
            console.log("Create order already in progress, ignoring duplicate call");
            return;
        }
        paymentLockRef.current = true;
        setPayLoading(true);
        try {
            const value = await createEventPageOrder(payload);
            if (value && value.eventPageOrderLink) {
                sessionStorage.removeItem('expiryTime');
                setPath(`/event-page-order/${value.eventPageOrderLink.gid}/pay`);
            }
        } catch (e) {
            console.log("Create order failed:", e);
            setPayNow(false);
            const errorMsg =e?.data?.message ||  e?.response?.data?.message || e?.message || "An error occurred";
            setErrorMessage(errorMsg);
             if (!e?.data?.message) {
                setPath(`/event-page/${eventDetails.gid}/error`);
            }
        } finally {
            setPayLoading(false);
            // Re-enable after a cooldown to prevent rapid bounce
            setTimeout(() => {
                paymentLockRef.current = false;
            }, 500);
        }
    };

    useEffect(() => {
        if (payNow && !payLoading && Object.keys(payload).length > 0 && payload.total > 0) {
            createOrderAndPay(payload);
        }
    }, [payload, payNow, payLoading]);

    useEffect(() => {
        if (errorMessage) {
            console.log("Error captured in EventPages:", errorMessage);
            debouncedNotify(errorMessage);
            setErrorMessage('');
        }
    }, [errorMessage, debouncedNotify]);

    useEffect(() => {
        const baseId = eventPageId.replace('eventpage-', '');
        sessionStorage.setItem('placedItems-' + baseId, JSON.stringify(orderItems));
    }, [orderItems]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                supportRef.current && !supportRef.current.contains(event.target) &&
                supportToggleRef.current && !supportToggleRef.current.contains(event.target)
            ) {
                setIsExpanded(false);
            }
        };

        if (isExpanded) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isExpanded]);

    // Initialize orderItems for non-seated events
    useEffect(() => {
        if (eventDetails && !eventDetails.isSeatedEvent && orderItems.length === 0) {
            const initialOrderItems = [];

            if (eventDetails.eventPageProducts) {
                eventDetails.eventPageProducts.forEach((product, index) => {
                    const orderItem = {
                        index,
                        productGid: product.gid,
                        name: product.eventPageProductName,
                        title: product.eventPageProductType === 'TICKET'
                            ? 'Ticket' : product.eventPageProductType === 'FOOD'
                                ? 'Food' : product.eventPageProductName,
                        lineItems: [],
                        totalAmount: 0,
                        totalCount: 0,
                    };

                    // Add basic items for non-seated events with quantity 1
                    if (product.items && product.items.length > 0) {
                        product.items.forEach(item => {
                            if (item.isActive) {
                                orderItem.lineItems.push({
                                    itemGid: item.gid,
                                    name: item.displayName || item.name,
                                    price: item.price || 0,
                                    quantity: 1,
                                    totalPrice: item.price || 0,
                                    lineItemModifiers: [],
                                    lineItemItems: [],
                                    lineItemDiscounts: []
                                });
                                orderItem.totalAmount += (item.price || 0);
                                orderItem.totalCount += 1;
                            }
                        });
                    }

                    if (orderItem.lineItems.length > 0) {
                        initialOrderItems.push(orderItem);
                    }
                });
            }

            if (initialOrderItems.length > 0) {
                setOrderItems(initialOrderItems);
            }
        }
    }, [eventDetails, orderItems.length]);

    return (<>
        <header className="figma-header">
            <div className="figma-header-content">
                <div className="figma-header-left">
                    <div className="figma-logo-container">
                        <img
                            alt="Logo"
                            src={eventDetails?.logo}
                            className="figma-logo"
                        />
                    </div>
                    <div className="figma-header-text">
                        <div className="figma-brand-name" dangerouslySetInnerHTML={{ __html: eventDetails?.bannerText ? Buffer.from(eventDetails.bannerText, 'base64').toString('utf8').replaceAll("<br>", "") : '' }} />
                        {/* Discount Badge in Header - Dual End Ribbon */}
                        {eventDetails?.coupon && (
                            <span 
                                className="discount-ribbon" 
                                style={{ 
                                    position: 'relative',
                                    display: 'inline-block',
                                    background: '#ef4444',
                                    color: '#fff',
                                    padding: '6px 16px',
                                    fontSize: '13px',
                                    fontWeight: '700',
                                    marginLeft: '16px',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                    letterSpacing: '0.5px',
                                }}
                            >
                                <span style={{ position: 'relative', zIndex: 1 }}>
                                    {eventDetails.coupon.percentageOff
                                        ? `${eventDetails.coupon.percentageOff}%`
                                        : `$ ${AmountDivideByHundred(eventDetails.coupon.amountOff)}`
                                    } OFF
                                </span>
                                {/* Left ribbon cut */}
                                <span style={{
                                    position: 'absolute',
                                    left: 0,
                                    top: 0,
                                    width: 0,
                                    height: 0,
                                    borderTop: '14px solid transparent',
                                    borderBottom: '14px solid transparent',
                                    borderRight: '8px solid #ef4444',
                                    transform: 'translateX(-8px)',
                                }} />
                                {/* Right ribbon cut */}
                                <span style={{
                                    position: 'absolute',
                                    right: 0,
                                    top: 0,
                                    width: 0,
                                    height: 0,
                                    borderTop: '14px solid transparent',
                                    borderBottom: '14px solid transparent',
                                    borderLeft: '8px solid #ef4444',
                                    transform: 'translateX(8px)',
                                }} />
                            </span>
                        )}
                        {/* <div className="figma-brand-subtitle" dangerouslySetInnerHTML={{ __html: eventDetails?.subBannerText ? Buffer.from(eventDetails.subBannerText, 'base64').toString('utf8').replaceAll("<br>", "") : 'Event Management Platform' }} /> */}
                    </div>
                </div>

                <div className="figma-header-right">
                    {(() => {
                        const primarySupport = eventDetails?.eventPageSupports?.find(s => s.isPrimary) || eventDetails?.eventPageSupports?.[0];
                        return (
                            <div className="figma-header-contact">
                                {primarySupport?.email && (
                                    <span className="figma-header-contact-link">
                                        <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clipPath="url(#clip0_2025_10260)">
                                                    <path d="M13.333 2.66699H2.66634C1.92996 2.66699 1.33301 3.26395 1.33301 4.00033V12.0003C1.33301 12.7367 1.92996 13.3337 2.66634 13.3337H13.333C14.0694 13.3337 14.6663 12.7367 14.6663 12.0003V4.00033C14.6663 3.26395 14.0694 2.66699 13.333 2.66699Z" stroke="white" strokeOpacity="0.9" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
                                                    <path d="M14.6663 4.66699L8.68634 8.46699C8.48052 8.59594 8.24255 8.66433 7.99967 8.66433C7.7568 8.66433 7.51883 8.59594 7.31301 8.46699L1.33301 4.66699" stroke="white" strokeOpacity="0.9" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_2025_10260">
                                                        <rect width="16" height="16" fill="white"/>
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            {primarySupport.email}
                                        </span>
                                    </span>
                                )}
                                {primarySupport?.phoneNumber && (
                                    <span className="figma-header-contact-link">
                                        <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M14.6669 11.2797V13.2797C14.6677 13.4654 14.6297 13.6492 14.5553 13.8193C14.4809 13.9894 14.3718 14.1421 14.235 14.2676C14.0982 14.3932 13.9367 14.4887 13.7608 14.5482C13.5849 14.6077 13.3985 14.6298 13.2136 14.6131C11.1622 14.3902 9.19161 13.6892 7.46028 12.5664C5.8495 11.5428 4.48384 10.1772 3.46028 8.56641C2.3336 6.82721 1.63244 4.84707 1.41361 2.78641C1.39695 2.60205 1.41886 2.41625 1.47795 2.24082C1.53703 2.0654 1.63199 1.9042 1.75679 1.76749C1.88159 1.63077 2.03348 1.52155 2.20281 1.44675C2.37213 1.37196 2.55517 1.33325 2.74028 1.33307H4.74028C5.06382 1.32989 5.37748 1.44446 5.62279 1.65543C5.8681 1.8664 6.02833 2.15937 6.07361 2.47974C6.15803 3.11978 6.31458 3.74822 6.54028 4.35307C6.62998 4.59169 6.64939 4.85102 6.59622 5.10033C6.54305 5.34964 6.41952 5.57848 6.24028 5.75974L5.39361 6.60641C6.34265 8.27544 7.72458 9.65737 9.39361 10.6064L10.2403 9.75974C10.4215 9.5805 10.6504 9.45697 10.8997 9.4038C11.149 9.35063 11.4083 9.37004 11.6469 9.45974C12.2518 9.68544 12.8802 9.84199 13.5203 9.92641C13.8441 9.97209 14.1399 10.1352 14.3513 10.3847C14.5627 10.6343 14.6751 10.9528 14.6669 11.2797Z" stroke="white" strokeOpacity="0.9" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                            {primarySupport.phoneNumber}
                                        </span>
                                    </span>
                                )}
                                {eventDetails?.eventPageSupports && eventDetails.eventPageSupports.length > 0 && (
                                    <div className="d-flex align-items-center" style={{ cursor: 'pointer', position: 'relative' }} ref={supportToggleRef}>
                                        <img
                                            alt="More Info"
                                            src={info}
                                            className="icon-height"
                                            onClick={() => setIsExpanded(!isExpanded)}
                                        />
                                        {/* Event Page Support List */}
                                        {isExpanded && (
                                            <div className="support-list" style={{ top: mobileView ? '30px' : '35px' }} ref={supportRef}>
                                                {eventDetails?.eventPageSupports?.map((support, index) => (
                                                    <div key={index}>
                                                        {/* Support Details */}
                                                        <div className="support-item">
                                                            {support.name ? <div style={{ fontWeight: 'bold' }}>{support.name}</div> : ''}
                                                            {support.email ? <div>{support.email}</div> : ''}
                                                            {support.phoneNumber ? <div>{support.phoneNumber}</div> : ''}
                                                            {support.designation ? <div>{support.designation}</div> : ''}
                                                        </div>

                                                        {/* Separator Line */}
                                                        {index < eventDetails.eventPageSupports.length - 1 && (
                                                            <div className="support-separator" />
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        );
                    })()}
                </div>
            </div>

            {/* Event Page Support List */}

        </header>

        <>{!productScreen ? (
            <div className="figma-event-page">
                {/* Blue Header */}


                {/* Mobile Event Details - Show after header on mobile */}
                {mobileView && (
                    <div className="figma-mobile-details">
                        <div className="figma-details-card">
                            <h3 className="figma-details-title">Event Details</h3>

                            {/* Date & Time */}
                            <div className="figma-detail-item">
                                <div className="figma-detail-icon">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.66699 1.66699V5.00033" stroke={eventDetails?.primaryColor || '#155DFC'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M13.333 1.66699V5.00033" stroke={eventDetails?.primaryColor || '#155DFC'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M15.8333 3.33301H4.16667C3.24619 3.33301 2.5 4.0792 2.5 4.99967V16.6663C2.5 17.5868 3.24619 18.333 4.16667 18.333H15.8333C16.7538 18.333 17.5 17.5868 17.5 16.6663V4.99967C17.5 4.0792 16.7538 3.33301 15.8333 3.33301Z" stroke={eventDetails?.primaryColor || '#155DFC'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M2.5 8.33301H17.5" stroke={eventDetails?.primaryColor || '#155DFC'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </div>
                                <div className="figma-detail-content">
                                    <div className="figma-detail-label">Date & Time</div>
                                    {eventDetails?.eventPageDateTimes?.length > 0 ? (
                                        <>
                                            {(showAllDates ? eventDetails.eventPageDateTimes : eventDetails.eventPageDateTimes.slice(0, 2)).map((dt, idx) => (
                                                <div key={idx} style={{ marginBottom: idx === 0 && !showAllDates && eventDetails.eventPageDateTimes.length > 1 ? '8px' : (idx < (showAllDates ? eventDetails.eventPageDateTimes.length : 2) - 1 ? '8px' : '0') }}>
                                                    <div className="figma-detail-value">
                                                        {moment.utc(dt.eventDate).format('MMM DD, YYYY')}
                                                    </div>
                                                    <div className="figma-detail-time">
                                                        {dt.eventStartTime ?
                                                            (dt.eventEndTime ?
                                                                `${getOperatingTime(dt.eventStartTime)} - ${getOperatingTime(dt.eventEndTime)}` :
                                                                getOperatingTime(dt.eventStartTime)
                                                            ) : ''
                                                        }
                                                    </div>
                                                </div>
                                            ))}
                                            {eventDetails.eventPageDateTimes.length > 2 && (
                                                <div
                                                    className="figma-view-more-dates"
                                                    onClick={() => setShowAllDates(!showAllDates)}
                                                    style={{ color: eventDetails.primaryColor || '#2563eb', cursor: 'pointer', fontSize: '13px', fontWeight: 'bold', marginTop: '8px', display: 'flex', alignItems: 'center', gap: '4px' }}
                                                >
                                                    {showAllDates ? '− View Less' : `+ View ${eventDetails.eventPageDateTimes.length - 2} More Dates`}
                                                </div>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            <div className="figma-detail-value">
                                                {eventDetails?.eventDate ? moment.utc(eventDetails.eventDate).format('MMM DD, YYYY') : ''}
                                            </div>
                                            <div className="figma-detail-time">
                                                {eventDetails?.eventStartTime ?
                                                    (eventDetails.eventEndTime ?
                                                        `${getOperatingTime(eventDetails.eventStartTime)} - ${getOperatingTime(eventDetails.eventEndTime)}` :
                                                        getOperatingTime(eventDetails.eventStartTime)
                                                    ) : ''
                                                }
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>

                            {/* Venue */}
                            <div className="figma-detail-item">
                                <div className="figma-detail-icon">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M16.6663 8.33366C16.6663 12.4945 12.0505 16.8278 10.5005 18.1662C10.3561 18.2747 10.1803 18.3335 9.99967 18.3335C9.81901 18.3335 9.64324 18.2747 9.49884 18.1662C7.94884 16.8278 3.33301 12.4945 3.33301 8.33366C3.33301 6.56555 4.03539 4.86986 5.28563 3.61961C6.53587 2.36937 8.23156 1.66699 9.99967 1.66699C11.7678 1.66699 13.4635 2.36937 14.7137 3.61961C15.964 4.86986 16.6663 6.56555 16.6663 8.33366Z" stroke={eventDetails?.primaryColor || '#155DFC'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M10 10.833C11.3807 10.833 12.5 9.71372 12.5 8.33301C12.5 6.9523 11.3807 5.83301 10 5.83301C8.61929 5.83301 7.5 6.9523 7.5 8.33301C7.5 9.71372 8.61929 10.833 10 10.833Z" stroke={eventDetails?.primaryColor || '#155DFC'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </div>
                                <div className="figma-detail-content">
                                    <div className="figma-detail-label">Venue</div>
                                    <div className="figma-detail-value">
                                        {eventDetails?.address?.street || ''}
                                    </div>
                                    <div className="figma-detail-address">
                                        {eventDetails?.address ?
                                            `${eventDetails.address.city}, ${eventDetails.address.state}, ${eventDetails.address.postalCode}, USA` :
                                            ''
                                        }
                                    </div>
                                </div>
                            </div>

                            {eventDetails?.coordinate && (
                                <>
                                    {/* Show in Map */}
                                    <div className="figma-map-link">
                                        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clipPath="url(#clip0_2280_4863)">
                                                    <path d="M16.4003 1.20855L13.1362 0.115796C12.702 -0.0316778 12.2327 -0.0408491 11.793 0.0895459L6.4035 1.56855L3.11625 0.174296C2.77442 0.031699 2.40267 -0.0243065 2.034 0.0112499C1.66533 0.0468062 1.31114 0.172825 1.00286 0.378121C0.694582 0.583418 0.441751 0.861642 0.266807 1.1881C0.0918629 1.51456 0.000215995 1.87916 0 2.24955L0 16.315L5.9865 18.0258L12.0023 16.5258L18.0023 17.9868V3.3618C18.0019 2.87842 17.846 2.40799 17.5574 2.02017C17.2689 1.63235 16.8631 1.34776 16.4003 1.20855ZM11.25 1.78755V15.1638L6.75 16.2888V2.97855L11.25 1.78755ZM1.5 2.24955C1.50026 2.12604 1.53101 2.00451 1.58952 1.89575C1.64804 1.78699 1.73251 1.69437 1.83543 1.6261C1.93835 1.55783 2.05654 1.51604 2.17949 1.50443C2.30245 1.49282 2.42637 1.51175 2.54025 1.55955L5.25 2.6853V16.255L1.5 15.184V2.24955ZM16.5 16.072L12.75 15.1585V1.56855L15.9563 2.64105C16.1129 2.68584 16.2506 2.7804 16.3487 2.91044C16.4468 3.04047 16.4999 3.19891 16.5 3.3618V16.072Z" fill={eventDetails?.primaryColor || '#155DFC'}/>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_2280_4863">
                                                        <rect width="18" height="18" fill="white"/>
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            Show in Map
                                        </span>
                                    </div>

                                    {/* Map */}
                                    <div className="figma-map-container">
                                        <Map
                                            google={props.google}
                                            zoom={14}
                                            style={{ width: '100%', height: '100%', position: 'relative' }}
                                            initialCenter={{
                                                lat: eventDetails?.coordinate?.x || eventDetails?.address?.latitude || null,
                                                lng: eventDetails?.coordinate?.y || eventDetails?.address?.longitude || null
                                            }}
                                            containerStyle={{ position: 'relative', width: '100%', height: '100%' }}
                                        >
                                            <Marker
                                                position={{
                                                    lat: eventDetails?.coordinate?.x || eventDetails?.address?.latitude || null,
                                                    lng: eventDetails?.coordinate?.y || eventDetails?.address?.longitude || null
                                                }}
                                            />
                                        </Map>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                )}

                {/* Main Content */}
                <main className="figma-main-content">
                    <div className="figma-content-wrapper">
                        {/* Left Content */}
                        <div className="figma-left-content">
                            {/* Event Title */}
                            <div className="figma-event-header">
                                <h1 className="figma-event-title">
                                    {eventDetails?.title || ''}
                                </h1>
                                {eventDetails?.subTitle && (
                                    <p className="figma-event-subtitle">
                                        {eventDetails.subTitle}
                                    </p>
                                )}
                            </div>

                            {/* Event Banner */}
                            <div className="figma-banner-container" style={{ height: mobileView ? '300px' : '500px', width: '100%', overflow: 'hidden', borderRadius: '16px', marginBottom: '32px', position: 'relative', background: '#f1f5f9' }}>
                                {bannerImages.length > 0 ? (
                                    bannerImages.map((img, idx) => (
                                        <div
                                            key={idx}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                opacity: idx === currentImageIndex ? 1 : 0,
                                                zIndex: idx === currentImageIndex ? 1 : 0,
                                                pointerEvents: idx === currentImageIndex ? 'auto' : 'none',
                                                transition: 'opacity 0.8s ease-in-out',
                                                cursor: 'pointer',
                                                overflow: 'hidden'
                                            }}
                                            onClick={() => openImageModal(img)}
                                        >
                                            <img
                                                src={img}
                                                alt=""
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    filter: 'blur(20px) brightness(0.8)',
                                                    transform: 'scale(1.1)',
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                }}
                                            />
                                            <img
                                                src={img}
                                                alt={`Event Banner ${idx}`}
                                                className="figma-banner-image"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain',
                                                    position: 'relative',
                                                    zIndex: 1,
                                                    opacity: 1 // Explicitly set to 1 to override CSS opacity definitions
                                                }}
                                            />
                                        </div>
                                    ))
                                ) : (
                                    <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#e2e8f0', color: '#94a3b8' }}>
                                        No Image Available
                                    </div>
                                )}

                                {bannerImages.length > 1 && (
                                    <>
                                        <button 
                                            className="figma-banner-nav-btn prev" 
                                            onClick={prevImage}
                                            style={{
                                                position: 'absolute',
                                                top: '50%',
                                                left: '20px',
                                                transform: 'translateY(-50%)',
                                                zIndex: 10,
                                                background: 'rgba(255, 255, 255, 0.2)',
                                                backdropFilter: 'blur(10px)',
                                                border: '1px solid rgba(255, 255, 255, 0.3)',
                                                borderRadius: '50%',
                                                width: '48px',
                                                height: '48px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                cursor: 'pointer',
                                                transition: 'all 0.2s',
                                                color: 'white',
                                                fontSize: '20px'
                                            }}
                                        >
                                            <LeftOutlined />
                                        </button>
                                        <button 
                                            className="figma-banner-nav-btn next" 
                                            onClick={nextImage}
                                            style={{
                                                position: 'absolute',
                                                top: '50%',
                                                right: '20px',
                                                transform: 'translateY(-50%)',
                                                zIndex: 10,
                                                background: 'rgba(255, 255, 255, 0.2)',
                                                backdropFilter: 'blur(10px)',
                                                border: '1px solid rgba(255, 255, 255, 0.3)',
                                                borderRadius: '50%',
                                                width: '48px',
                                                height: '48px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                cursor: 'pointer',
                                                transition: 'all 0.2s',
                                                color: 'white',
                                                fontSize: '20px'
                                            }}
                                        >
                                            <RightOutlined />
                                        </button>
                                        <div className="figma-banner-dots" style={{
                                            position: 'absolute',
                                            bottom: '20px',
                                            left: '50%',
                                            transform: 'translateX(-50%)',
                                            zIndex: 10,
                                            display: 'flex',
                                            gap: '8px',
                                            background: 'rgba(0,0,0,0.2)',
                                            padding: '6px 12px',
                                            borderRadius: '20px',
                                            backdropFilter: 'blur(4px)'
                                        }}>
                                            {bannerImages.map((_, idx) => (
                                                <div 
                                                    key={idx}
                                                    onClick={(e) => { e.stopPropagation(); setCurrentImageIndex(idx); }}
                                                    style={{
                                                        width: '8px',
                                                        height: '8px',
                                                        borderRadius: '50%',
                                                        background: idx === currentImageIndex ? 'white' : 'rgba(255,255,255,0.4)',
                                                        cursor: 'pointer',
                                                        transition: 'all 0.2s'
                                                    }}
                                                />
                                            ))}
                                        </div>
                                    </>
                                )}
                            </div>
                            {/* Event Description */}
                            <section className="figma-section">
                                <h2 className="figma-section-title">Event Description</h2>
                                <div className="figma-section-content">
                                    {eventDetails?.description ? (
                                        <div>
                                            <div
                                                ref={contentRef}
                                                className={`figma-description-text ${isDescriptionExpanded ? 'expanded' : 'collapsed'}`}
                                                dangerouslySetInnerHTML={{
                                                    __html: Buffer.from(eventDetails.description, 'base64')
                                                        .toString('utf8')
                                                        .replaceAll("<br>", ""),
                                                }}
                                            />
                                            {isOverflowing && (
                                                <button
                                                    className="figma-read-more-btn"
                                                    style={{ color: eventDetails?.primaryColor || '#2563eb' }}
                                                    onClick={toggleReadMore}
                                                >
                                                    {isDescriptionExpanded ? "Read Less" : "Read More"}
                                                </button>
                                            )}
                                        </div>
                                    ) : (
                                        <p>Swirepay is one of online payments orchestration and reconciliation platform, empowering businesses to seamlessly accept payments via Point of Interest, discount funds to employees or vendors, and reconcile accounts seamlessly. With Swirepay, you can...</p>
                                    )}
                                </div>
                            </section>

                            {/* Event Preview */}
                            {eventDetails?.ytVideoId && (
                                <section className="figma-section">
                                    <h2 className="figma-section-title">{eventDetails?.ytVideoHeading || "Event Preview"}</h2>
                                    <div className="figma-video-container">
                                        <iframe
                                            src={`https://www.youtube.com/embed/${extractYoutubeId(eventDetails.ytVideoId)}`}
                                            title={eventDetails?.ytVideoHeading || "Event Preview"}
                                            className="figma-video-iframe"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                        />
                                    </div>
                                    {eventDetails?.ytVideoDescription ? <div className="figma-video-description">
                                        <h3>{"Video Description"}</h3>
                                        <div
                                            ref={videoDescRef}
                                            className={`figma-description-text ${isVideoDescExpanded ? 'expanded' : 'collapsed'}`}
                                            style={{ color: '#4b5563' }}
                                        >
                                            {eventDetails?.ytVideoDescription || ""}
                                        </div>
                                        {isVideoDescOverflowing && (
                                            <button
                                                className="figma-read-more-btn"
                                                style={{ color: eventDetails?.primaryColor || '#2563eb' }}
                                                onClick={() => setIsVideoDescExpanded(!isVideoDescExpanded)}
                                            >
                                                {isVideoDescExpanded ? "Read Less" : "Read More"}
                                            </button>
                                        )}
                                    </div>:null}
                                    
                                </section>
                            )}
                            {/* Terms and Conditions */}
                             {eventDetails?.termsAndConditions && (
                                <section className="figma-section">
                                    <h2 className="figma-section-title">Terms & Conditions</h2>
                                    <div className="figma-section-content">
                                        <div
                                            ref={termsRef}
                                            className={`figma-description-text ${isTermsExpanded ? 'expanded' : 'collapsed'}`}
                                            style={{ color: '#4b5563', whiteSpace: 'pre-wrap' }}
                                        >
                                            {eventDetails.termsAndConditions}
                                        </div>
                                        {isTermsOverflowing && (
                                            <button
                                                className="figma-read-more-btn"
                                                style={{ color: eventDetails?.primaryColor || '#2563eb', marginTop: '8px' }}
                                                onClick={() => setIsTermsExpanded(!isTermsExpanded)}
                                            >
                                                {isTermsExpanded ? "Read Less" : "Read More"}
                                            </button>
                                        )}
                                    </div>
                                </section>
                            )}

                            {/* Support Section */}
                            <section className="figma-support-section">
                                <h3>Have Questions?</h3>
                                <p>For any inquiries please contact our support team</p>
                                <div className="figma-support-buttons">
                                    {(() => {
                                        const primarySupport = eventDetails?.eventPageSupports?.find(s => s.isPrimary) || eventDetails?.eventPageSupports?.[0];
                                        return (
                                            <>
                                                {primarySupport?.email && (
                                                    <button
                                                        onClick={() => openMail(primarySupport.email)}
                                                        className="figma-support-btn"
                                                    >Email Support</button>
                                                )}
                                                {primarySupport?.phoneNumber && (
                                                    <a
                                                        href={`tel:${primarySupport.phoneNumber}`}
                                                        className="figma-support-btn"
                                                    >Call Us</a>
                                                )}
                                            </>
                                        );
                                    })()}
                                </div>
                            </section>
                        </div>

                        {/* Right Sidebar */}
                        <div className="figma-right-sidebar">
                            {/* Book Button */}
                            <div className="figma-book-section">
                                <button
                                    className="figma-book-btn"
                                    disabled={!eventDetails}
                                    onClick={products}
                                >
                                   {eventDetails?.buttonLabel ? eventDetails?.buttonLabel : 'Book Your Seat Now'} 
                                </button>
                            </div>

                            {/* Event Details */}
                            <div className="figma-details-card">
                                <h3 className="figma-details-title">Event Details</h3>

                                {/* Date & Time */}
                                <div className="figma-detail-item">
                                    <div className="figma-detail-icon">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6.66699 1.66699V5.00033" stroke={eventDetails?.primaryColor || '#155DFC'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                                            <path d="M13.333 1.66699V5.00033" stroke={eventDetails?.primaryColor || '#155DFC'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                                            <path d="M15.8333 3.33301H4.16667C3.24619 3.33301 2.5 4.0792 2.5 4.99967V16.6663C2.5 17.5868 3.24619 18.333 4.16667 18.333H15.8333C16.7538 18.333 17.5 17.5868 17.5 16.6663V4.99967C17.5 4.0792 16.7538 3.33301 15.8333 3.33301Z" stroke={eventDetails?.primaryColor || '#155DFC'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                                            <path d="M2.5 8.33301H17.5" stroke={eventDetails?.primaryColor || '#155DFC'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    </div>
                                    <div className="figma-detail-content">
                                        <div className="figma-detail-label">Date & Time</div>
                                        {eventDetails?.eventPageDateTimes?.length > 0 ? (
                                            <>
                                                {(showAllDates ? eventDetails.eventPageDateTimes : eventDetails.eventPageDateTimes.slice(0, 2)).map((dt, idx) => (
                                                    <div key={idx} style={{ marginBottom: idx === 0 && !showAllDates && eventDetails.eventPageDateTimes.length > 1 ? '8px' : (idx < (showAllDates ? eventDetails.eventPageDateTimes.length : 2) - 1 ? '8px' : '0') }}>
                                                        <div className="figma-detail-value">
                                                            {moment.utc(dt.eventDate).format('MMM DD, YYYY')}
                                                        </div>
                                                        <div className="figma-detail-time">
                                                            {getEventTimeRange(dt)}
                                                        </div>
                                                    </div>
                                                ))}
                                                {eventDetails.eventPageDateTimes.length > 2 && (
                                                    <div
                                                        className="figma-view-more-dates"
                                                        onClick={() => setShowAllDates(!showAllDates)}
                                                        style={{ color: eventDetails.primaryColor || '#2563eb', cursor: 'pointer', fontSize: '13px', fontWeight: 'bold', marginTop: '8px', display: 'flex', alignItems: 'center', gap: '4px' }}
                                                    >
                                                        {showAllDates ? '− View Less' : `+ View ${eventDetails.eventPageDateTimes.length - 2} More Dates`}
                                                    </div>
                                                )}
                                            </>
                                        ) : (
                                            <>
                                                <div className="figma-detail-value">
                                                    {eventDetails?.eventDate ? moment.utc(eventDetails.eventDate).format('MMM DD, YYYY') : ''}
                                                </div>
                                                <div className="figma-detail-time">
                                                    {getEventTimeRange(eventDetails)}
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>

                                {/* Venue */}
                                <div className="figma-detail-item">
                                    <div className="figma-detail-icon">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M16.6663 8.33366C16.6663 12.4945 12.0505 16.8278 10.5005 18.1662C10.3561 18.2747 10.1803 18.3335 9.99967 18.3335C9.81901 18.3335 9.64324 18.2747 9.49884 18.1662C7.94884 16.8278 3.33301 12.4945 3.33301 8.33366C3.33301 6.56555 4.03539 4.86986 5.28563 3.61961C6.53587 2.36937 8.23156 1.66699 9.99967 1.66699C11.7678 1.66699 13.4635 2.36937 14.7137 3.61961C15.964 4.86986 16.6663 6.56555 16.6663 8.33366Z" stroke={eventDetails?.primaryColor || '#155DFC'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                                            <path d="M10 10.833C11.3807 10.833 12.5 9.71372 12.5 8.33301C12.5 6.9523 11.3807 5.83301 10 5.83301C8.61929 5.83301 7.5 6.9523 7.5 8.33301C7.5 9.71372 8.61929 10.833 10 10.833Z" stroke={eventDetails?.primaryColor || '#155DFC'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    </div>
                                    <div className="figma-detail-content">
                                        <div className="figma-detail-label">Venue</div>
                                        <div className="figma-detail-value">
                                            {eventDetails?.address?.street || ''}
                                        </div>
                                        <div className="figma-detail-address">
                                            {eventDetails?.address ?
                                                `${eventDetails.address.city}, ${eventDetails.address.state}, ${eventDetails.address.postalCode}, USA` :
                                                ''
                                            }
                                        </div>
                                    </div>
                                </div>

                                {eventDetails?.coordinate && (
                                    <>
                                        {/* Show in Map */}
                                        <div className="figma-map-link">
                                            <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clipPath="url(#clip0_2280_4863_desktop)">
                                                        <path d="M16.4003 1.20855L13.1362 0.115796C12.702 -0.0316778 12.2327 -0.0408491 11.793 0.0895459L6.4035 1.56855L3.11625 0.174296C2.77442 0.031699 2.40267 -0.0243065 2.034 0.0112499C1.66533 0.0468062 1.31114 0.172825 1.00286 0.378121C0.694582 0.583418 0.441751 0.861642 0.266807 1.1881C0.0918629 1.51456 0.000215995 1.87916 0 2.24955L0 16.315L5.9865 18.0258L12.0023 16.5258L18.0023 17.9868V3.3618C18.0019 2.87842 17.846 2.40799 17.5574 2.02017C17.2689 1.63235 16.8631 1.34776 16.4003 1.20855ZM11.25 1.78755V15.1638L6.75 16.2888V2.97855L11.25 1.78755ZM1.5 2.24955C1.50026 2.12604 1.53101 2.00451 1.58952 1.89575C1.64804 1.78699 1.73251 1.69437 1.83543 1.6261C1.93835 1.55783 2.05654 1.51604 2.17949 1.50443C2.30245 1.49282 2.42637 1.51175 2.54025 1.55955L5.25 2.6853V16.255L1.5 15.184V2.24955ZM16.5 16.072L12.75 15.1585V1.56855L15.9563 2.64105C16.1129 2.68584 16.2506 2.7804 16.3487 2.91044C16.4468 3.04047 16.4999 3.19891 16.5 3.3618V16.072Z" fill={eventDetails?.primaryColor || '#155DFC'}/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_2280_4863_desktop">
                                                            <rect width="18" height="18" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                Show in Map
                                            </span>
                                        </div>

                                        {/* Map */}
                                        <div className="figma-map-container">
                                            <Map
                                                google={props.google}
                                                zoom={14}
                                                style={{ width: '100%', height: '100%', position: 'relative' }}
                                                initialCenter={{
                                                    lat: eventDetails?.coordinate?.x || eventDetails?.address?.latitude || null,
                                                    lng: eventDetails?.coordinate?.y || eventDetails?.address?.longitude || null
                                                }}
                                                containerStyle={{ position: 'relative', width: '100%', height: '100%' }}
                                            >
                                                <Marker
                                                    position={{
                                                        lat: eventDetails?.coordinate?.x || eventDetails?.address?.latitude || null,
                                                        lng: eventDetails?.coordinate?.y || eventDetails?.address?.longitude || null
                                                    }}
                                                />
                                            </Map>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </main>

                {/* Mobile Footer */}
                {mobileView && (
                    <div className="figma-mobile-footer">
                        <button
                            className="figma-mobile-book-btn"
                            disabled={!eventDetails}
                            onClick={products}
                        >
                            {eventDetails?.buttonLabel ? eventDetails?.buttonLabel : 'Book Your Seat Now'}
                        </button>
                    </div>
                )}

                <Spinner isOpen={isShowSpinner} />
                <SoldOutModal body={
                    <>
                        Sorry! We are sold out for event:{" "}
                        {eventDetails && <span style={{ fontWeight: "bold" }}>{eventDetails.title}</span>}
                    </>
                } icon={sorry} isOpen={eventDetails && eventDetails.status === 'SOLD_OUT'} />
                <SoldOutModal body={
                    <>
                        Sorry! {eventDetails && <span style={{ fontWeight: "bold" }}>{eventDetails.title}</span>} is Closed.
                    </>
                } icon={sorry} isOpen={eventDetails && eventDetails.status === 'DEACTIVATED'} />
            </div>
        ) : (
            eventDetails?.isSeatedEvent ? (
                <Products
                    eventDetails={eventDetails}
                    getOperatingTime={getOperatingTime}
                    setPath={setPath}
                    close={products}
                    expiredToken={expiredToken}
                    selectedDate={selectedDate}
                    setSelectedDate={setSelectedDate}
                />
            ) : (
                <div className="figma-event-page" style={{ minHeight: '100vh', background: '#f8fafc' }}>
                    <ProductReview
                        eventDetails={eventDetails}
                        orderItems={orderItems}
                        setOrderItems={setOrderItems}
                        setPayload={setPayload}
                        setPayNow={setPayNow}
                        payNow={payNow}
                        setErrorMessage={setErrorMessage}
                        getOperatingTime={getOperatingTime}
                        mobileView={mobileView}
                        handleBack={products}
                        selectedDate={selectedDate}
                        setSelectedDate={setSelectedDate}
                    />

                    <SoldOutModal body={
                        <div className="d-flex align-items-center justify-content-center" style={{ flexDirection: 'column', textAlign: 'center', padding: '20px' }}>
                            <div className='spinner-border loader' />
                            <div className="loader-message">
                                Your order is being processed... <br />
                                Please wait and avoid closing or reloading this page. <br />
                                Thank you for your patience!
                            </div>
                        </div>
                    } isOpen={payLoading} />
                </div>
            )
        )}

            {/* Image Preview Modal */}
            {isImageModalOpen && (
                <div className="figma-image-modal-overlay" onClick={closeImageModal}>
                    <div className="figma-image-modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="figma-image-modal-close" onClick={closeImageModal}>
                            ×
                        </button>
                        <div style={{ position: 'relative', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', borderRadius: '12px' }}>
                            <img
                                src={modalImageSrc}
                                alt=""
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    filter: 'blur(30px) brightness(0.7)',
                                    transform: 'scale(1.1)',
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                }}
                            />
                            <img
                                src={modalImageSrc}
                                alt="Event Banner Preview"
                                className="figma-image-modal-image"
                                style={{
                                    position: 'relative',
                                    zIndex: 1,
                                    maxWidth: '100%',
                                    maxHeight: '90vh',
                                    objectFit: 'contain',
                                    border: 'none', // Removing the white border for a cleaner look with the blurred background
                                    boxShadow: 'none' // Shadow is handled by the container if needed, or unnecessary with blur
                                }}
                            />
                        </div>
                    </div>
                </div>
            )}
        </></>);
};

export default GoogleApiWrapper({
    apiKey: 'AIzaSyCLR2kMaQ9AHIa_tqsG48hxA9CZ7ullXds'
})(EventPages);